import { gql } from '@apollo/client';

/** Selfcare renewal: the customer confirms the createSo data (birth date, exam wishes, contact) before the offers. */
export const confirmRenewalSoDataAdditionalMutation = gql`
mutation ConfirmRenewalSoData($id: String!, $input: ConfirmRenewalSoDataInput!) {
  confirmRenewalSoData(id: $id, input: $input)
}`;
